import { atom } from "recoil";

const LeadFormAtom = atom<boolean>({
  key: "LeadFormAtom",
  default: false,
});

export { LeadFormAtom };
